<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton>
      <template slot="top-right-slot">
        <!-- 銷售訂單 -->
        <FormButton
          v-if="$validate.DataValid(id) && canViewOrder"
          text="salesOrder"
          class="ml-2"
          :to="{ name: 'OnlineCourseOrderList', params: { cid: id } }"
        />
      </template>
    </PageHeaderSlot>

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="status"
                placeholder="status"
                :fieldValue.sync="formData.status"
                :options="statusOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="courseName"
                placeholder="courseName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="courseCategory"
                placeholder="selectCourseCategory"
                :fieldValue.sync="formData.category_id"
                :options="categoryOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="originalPrice"
                placeholder="originalPrice"
                :fieldValue.sync="formData.price"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                prefix="HK$"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="discountPrice"
                placeholder="discountPrice"
                :fieldValue.sync="formData.discount_price"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                prefix="HK$"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormUploader
                uploadText="uploadCover"
                fileInputKey="upload_thumbnail"
                :files.sync="formData.thumbnail_list"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                single
              />
            </v-col>
            <v-col cols="12">
              <FormTextarea label="shortDescription" :fieldValue.sync="formData.short_description" />
            </v-col>
            <v-col cols="12">
              <QuillEditor :html.sync="formData.description_content" editorID="courseDes" label="introduction" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 章節 -->
      <v-card class="mt-4">
        <v-card-title class="px-4 d-flex align-center" tag="div">
          {{ $t('chapter') }}
          <FormButton text="add" isAdd class="ml-6" @click="handleAddChapter()" />
        </v-card-title>
        <v-card-text class="px-2">
          <Datatable
            :isLoading="loading"
            :tableHeaders="chapterTableHeaders"
            :tableData.sync="chapterList"
            enableDrag
            @edit-clicked="handleAddChapter($event)"
            @delete-clicked="deleteChapter($event)"
            :dispatchUpdateOnChange="dispatchUpdateOnChange"
          />
        </v-card-text>
      </v-card>
      <!-- 影片 -->
      <v-card class="mt-4">
        <v-card-title class="px-4 d-flex align-center" tag="div">
          {{ $t('video') }}
          <FormButton text="add" isAdd class="ml-6" @click="handleAddVideo()" />
        </v-card-title>
        <v-card-text class="px-2">
          <Datatable
            :isLoading="loading"
            :tableHeaders="videoTableHeaders"
            :tableData.sync="videoList"
            enableDrag
            @edit-clicked="handleAddVideo($event)"
            @delete-clicked="deleteVideo($event)"
            :dispatchUpdateOnChange="dispatchUpdateOnChange"
          >
            <template v-slot:[`item.thumbnail`]="{ item }">
              <v-img
                :src="`${$mediaPath}${item.thumbnail}`"
                contain
                :max-height="200"
                :max-width="200"
                @click="showPreviewImage(`${$mediaPath}${item.thumbnail}`)"
              ></v-img>
            </template>
            <template v-slot:[`item.chapter_name`]="{ item }">{{ getVideoChapterName(item.id) }}</template>
            <template v-slot:[`item.duration`]="{ item }">{{ gfConvertDuration(item.duration) }}</template>
            <template v-slot:[`item.actionPlayer`]="{ item }">
              <v-btn
                v-if="item.videoInput && item.videoInput.url"
                depressed
                text
                color="primary"
                :ripple="false"
                class="pa-0"
                small
                @click.prevent="showPreviewVideo(item.videoInput.url)"
              >
                <v-icon class="fi fi-rr-play-circle mr-1" size="18"></v-icon>
                {{ $t('playVideo') }}
              </v-btn>
            </template>
          </Datatable>
        </v-card-text>
      </v-card>
      <!-- 導師 -->
      <v-card class="mt-4">
        <v-card-title class="px-4 d-flex align-center" tag="div">
          {{ $t('tutor') }}
          <FormButton text="add" isAdd class="ml-6" @click="handleAddTutor()" />
        </v-card-title>
        <v-card-text class="px-2">
          <Datatable
            :isLoading="loading"
            :tableHeaders="tutorTableHeaders"
            :tableData.sync="tutorList"
            enableDrag
            @edit-clicked="handleAddTutor($event)"
            @delete-clicked="deleteTutor($event)"
            :dispatchUpdateOnChange="dispatchUpdateOnChange"
          />
        </v-card-text>
      </v-card>
      <!-- FAQ -->
      <v-card class="mt-4">
        <v-card-title class="px-4 d-flex align-center" tag="div">
          {{ $t('faq') }}
          <FormButton text="add" isAdd class="ml-6" @click="handleAddFAQ()" />
        </v-card-title>
        <v-card-text class="px-2">
          <Datatable
            :isLoading="loading"
            :tableHeaders="faqTableHeaders"
            :tableData.sync="faqList"
            enableDrag
            @edit-clicked="handleAddFAQ($event)"
            @delete-clicked="deleteFAQ($event)"
            :dispatchUpdateOnChange="dispatchUpdateOnChange"
          />
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>

    <!-- Modal: 章節 -->
    <FormDialog title="chapter" ref="chapterDialog" formRef="chapterForm" :maxWidth="500">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="chapterName" :fieldValue.sync="chapterData.title" required />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 影片 -->
    <FormDialog title="video" ref="videoDialog" formRef="videoForm">
      <v-row class="ma-0">
        <v-col cols="12" sm="6">
          <FormInput label="videoName" :fieldValue.sync="videoData.title" required />
        </v-col>
        <v-col cols="12" sm="6">
          <FormSelect
            label="chapter"
            placeholder="chapter"
            :fieldValue.sync="videoData.chapter"
            :options="chapterOptions"
            required
          />
        </v-col>
        <v-col cols="12">
          <QuillEditor :html.sync="videoData.description_content" editorID="videoDes" label="introduction" />
        </v-col>
        <v-col cols="12" sm="6">
          <FormUploader
            ref="uploadCoverRef"
            uploadText="uploadCover"
            fileInputKey="upload_video_thumbnail"
            :files.sync="videoData.thumbnail_list"
            single
          />
        </v-col>
        <v-col cols="12" sm="6">
          <FormUploader
            ref="uploadVideoRef"
            fileInputKey="upload_video"
            :files.sync="videoData.video_list"
            required
            :acceptFormat="['vimeo']"
            single
          />
        </v-col>
      </v-row>

      <Datatable
        tableName="homework"
        class="mt-4"
        :tableHeaders="homeworkTableHeaders"
        :tableData.sync="videoData.homework"
        enableDrag
        @edit-clicked="handleAddHomework($event)"
        @delete-clicked="deleteHomework($event)"
      >
        <template slot="append-toolbar-left">
          <FormButton text="add" isAdd class="ml-1 my-2" @click="handleAddHomework()" />
        </template>

        <template v-slot:[`item.file`]="{ item }">
          <v-btn @click.prevent="previewHomework(item.file)" text depressed small color="primary">
            {{ item.file }}
          </v-btn>
        </template>
      </Datatable>
    </FormDialog>

    <!-- Modal: 影片作業 -->
    <FormDialog title="homework" :maxWidth="500" ref="homeworkDialog" formRef="homeworkForm">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="title" :fieldValue.sync="homeworkData.title" required />
        </v-col>
        <v-col cols="12">
          <FormUploader
            ref="uploadHomeworkFileRef"
            uploadText="uploadDoc"
            fileInputKey="upload_video_homework"
            :files.sync="homeworkData.file_list"
            :acceptFormat="['image', 'pdf']"
            single
            required
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 導師 -->
    <FormDialog title="tutor" ref="tutorDialog" formRef="tutorForm">
      <v-row class="ma-0">
        <v-col cols="12" sm="6">
          <FormInput label="tutorName" :fieldValue.sync="tutorData.name" required />
        </v-col>
        <v-col cols="12">
          <QuillEditor :html.sync="tutorData.description" editorID="tutorDes" label="introduction" />
        </v-col>
        <v-col cols="12" sm="6">
          <FormUploader
            ref="uploadTutorIconRef"
            uploadText="addImage"
            fileInputKey="upload_tutor_icon"
            :files.sync="tutorData.icon_list"
            single
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: FAQ -->
    <FormDialog title="faq" :maxWidth="600" ref="faqDialog" formRef="faqForm">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="question" :fieldValue.sync="faqData.question" required />
        </v-col>
        <v-col cols="12">
          <FormTextarea label="answer" :fieldValue.sync="faqData.answer" required />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
import FormDialog from '@/components/FormDialog.vue'
import QuillEditor from '@/components/formField/QuillEditor.vue'
import FormTextarea from '@/components/formField/FormTextarea.vue'
import FormUploader from '@/components/formField/FormUploader.vue'

export default {
  name: 'OnlineCourseDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
    FormUploader,
    Datatable,
    FormDialog,
    QuillEditor,
    FormTextarea,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
    chapterOptions() {
      return this.chapterList.map(item => {
        return { value: item.id, text: item.title }
      })
    },
    // permission & setting
    canViewOrder() {
      return this.$validate.allowAction('OrderList', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    loading: false,
    count: 0,
    formData: {
      id: null,
      thumbnail_list: [],
      name: '',
      category_id: null,
      price: '',
      discount_price: '',
      status: 'active',
      description_content: '',
      short_description: '',
    },

    chapterList: [],
    chapterData: {
      title: '',
    },

    videoList: [],
    videoData: {
      title: '',
      chapter: null,
      thumbnail_list: [],
      description_content: '',
      homework: [],
      video_list: [],
    },
    savedVideoIds: [],
    homeworkData: {
      title: '',
      file_list: [],
    },

    tutorList: [],
    tutorData: {
      name: '',
      description: '',
      icon_list: [],
    },

    faqList: [],
    faqData: {
      question: '',
      answer: '',
    },

    // -- static
    categoryOptions: [],
    statusOptions: [
      { value: 'active', text: vm.$t('onlineCourseStatus.active') },
      { value: 'inactive', text: vm.$t('onlineCourseStatus.inactive') },
    ],
    chapterTableHeaders: [
      { value: 'title', text: vm.$t('chapterName') },
      { value: 'minActionEditAndDelete', text: '', align: 'end' },
    ],
    videoTableHeaders: [
      { value: 'thumbnail', text: vm.$t('videoCover'), width: 230 },
      { value: 'title', text: vm.$t('videoName') },
      { value: 'chapter_name', text: vm.$t('chapter') },
      { value: 'duration', text: vm.$t('videoDuration') },
      { value: 'actionPlayer', text: '', align: 'end', width: 80 },
      { value: 'minActionEditAndDelete', text: '', align: 'end', width: 120 },
    ],
    tutorTableHeaders: [
      { value: 'name', text: vm.$t('tutorName') },
      { value: 'minActionEditAndDelete', text: '', align: 'end' },
    ],
    faqTableHeaders: [
      { value: 'question', text: vm.$t('question'), width: 250 },
      { value: 'answer', text: vm.$t('answer') },
      { value: 'minActionEditAndDelete', text: '', align: 'end' },
    ],
    homeworkTableHeaders: [
      { value: 'title', text: vm.$t('title') },
      { value: 'file', text: vm.$t('uploadDoc') },
      { value: 'minActionEditAndDelete', text: '', align: 'end' },
    ],
  }),
  methods: {
    async _getCourseById() {
      const getUser = this.gfGetCurrentUserData()

      try {
        const data = await this.$Fetcher.GetOnlineCourseById(this.id, {
          access_token: getUser.access_token,
          refresh_token: getUser.refresh_token,
          get_chapter_data: true,
        })
        this.formData.id = this.id
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
        if (data.thumbnail) {
          this.formData.thumbnail_list = [{ file: data.thumbnail, name: data.thumbnail }]
        }

        this.chapterList = data.chapter_category_list.map(item => {
          this.count += 1
          return {
            id: this.count,
            ...item,
          }
        })
        this.videoList = data.lecture_video_list.map(item => {
          return {
            ...item,
            videoInput: {
              url: item.video_url,
              file: null,
              name: item.video_title || '',
              video_id: item.video_id,
              duration: item.duration,
            },
            initVideoId: item.video_id,
          }
        })
        this.savedVideoIds = data.lecture_video_list.map(item => item.video_id)
        this.tutorList = data.tutor_information.map(item => {
          this.count += 1
          return {
            id: this.count,
            ...item,
          }
        })
        this.faqList = data.faq_list.map(item => {
          this.count += 1
          return {
            id: this.count,
            ...item,
          }
        })

        this.$common.logData(this.chapterList, '章節')
        this.$common.logData(this.videoList, '影片')
        this.$common.logData(this.tutorList, '導師')
        this.$common.logData(this.faqList, 'FAQ')
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          if (err === 'message.loginExpired') {
            this.showAlert({
              isError: true,
              message: err,
              returnLink: 'Login',
            })
          } else {
            this.showAlert({
              message: 'noData',
              returnLink: 'OnlineCourseList',
            })
          }
        }
      }
    },
    async _getCategoryOptions() {
      try {
        const { data } = await this.$Fetcher.GetOnlineCourseCategories()
        this.categoryOptions = data.map(el => {
          return {
            value: el.id,
            text: el.name,
          }
        })
      } catch {}
    },

    // -- (確認)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      // check 影片
      let videoChapterValid = true
      let videoValid = true
      for (let i = 0; i < this.videoList.length; i++) {
        const foundChapter = this.getVideoChapter(this.videoList[i].id)
        if (!foundChapter) {
          videoChapterValid = false
        }

        if (!this.videoList[i].videoInput) {
          videoValid = false
        }
      }
      if (!videoChapterValid) {
        this.$store.dispatch('toggleSnack', { type: 'error', message: 'message.videoChapterInv' })
        return
      }
      if (!videoValid) {
        this.$store.dispatch('toggleSnack', { type: 'error', message: 'message.videoVideoInv' })
        return
      }

      this.$store.dispatch('setLoading', true)

      const payload = {
        name: this.formData.name,
        category_id: this.formData.category_id,
        status: this.formData.status,
        short_description: this.formData.short_description,
        thumbnail: this.formData.thumbnail_list.length ? this.formData.thumbnail_list[0].file : '',
        description_content: this.formData.description_content,
        price: this.formData.price ? parseFloat(this.formData.price) : 0,
        discount_price: this.formData.discount_price ? parseFloat(this.formData.discount_price) : 0,
        chapter_category_list: [],
        tutor_information: [],
        faq_list: [],
      }

      // update返chapter's video 做最新嘅list
      this.chapterList = this.chapterList.map(el => {
        return {
          ...el,
          chapter_id_list: this.videoList.filter(video => el.chapter_id_list.includes(video.id)).map(video => video.id),
        }
      })
      this.$common.logData(this.chapterList, '章節')

      // 章節 & 影片
      if (this.chapterList.length) {
        payload['chapter_category_list'] = this.chapterList.map(el => {
          return {
            title: el.title,
            chapter_id_list: this.videoList
              .filter(video => video.id > 0 && el.chapter_id_list.includes(video.id))
              .map(video => video.id),
          }
        })
      }

      // 導師
      if (this.tutorList.length) {
        payload['tutor_information'] = this.tutorList.map(el => {
          return {
            name: el.name,
            description: el.description,
            icon: el.icon,
          }
        })
      }

      // FAQ
      if (this.faqList.length) {
        payload['faq_list'] = this.faqList.map(el => {
          return {
            question: el.question,
            answer: el.answer,
          }
        })
      }

      if (this.$validate.DataValid(this.formData.id)) {
        try {
          const created = await this._createCourseVideos(payload)
          if (created === true) {
            // update existing video
            const updated = await this._updateCourseVideos()
            if (updated) {
              // remove unused vimeo
              await this.removeVimeo()
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('setDataIsUpdated', false)

              this.$store.dispatch('toggleSnack', {
                message: 'message.saveSuccess',
                type: 'success',
                refresh: this.$validate.DataValid(this.id),
                redirect: this.$validate.DataValid(this.id) ? '' : 'OnlineCourseList',
              })
            } else {
              this.$store.dispatch('setLoading', false)
              this.showAlert({
                title: 'message.someVideoCreateFail',
                message: updated,
                isError: true,
              })
            }
          } else {
            this.$store.dispatch('setLoading', false)
            this.showAlert({
              title: 'message.someVideoCreateFail',
              message: created,
              isError: true,
            })
          }
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
      } else {
        try {
          // Step 1: 先create咗course data
          const data = await this.$Fetcher.NewOnlineCourse(payload)
          this.formData.id = data.id

          const vm = this
          setTimeout(async () => {
            // Step 2: create videos & update video to course data
            const created = await vm._createCourseVideos()

            if (created === true) {
              // success
              // Step 3: remove unused vimeo
              await vm.removeVimeo()
              vm.$store.dispatch('setLoading', false)
              vm.$store.dispatch('setDataIsUpdated', false)

              vm.$store.dispatch('toggleSnack', {
                message: 'message.createSuccess',
                type: 'success',
                redirect: 'OnlineCourseList',
              })
            } else {
              vm.$store.dispatch('setLoading', false)
              vm.showAlert({
                title: 'message.someVideoCreateFail',
                message: created,
                isError: true,
              })
            }
          }, 500)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
        }
      }
    },
    async _createCourseVideos(payload = {}) {
      // create 新video data, 將新video id update落 chapter list同video list
      let results = []
      if (this.chapterList.length) {
        const promises = []
        for (let i = 0; i < this.chapterList.length; i++) {
          for (let j = 0; j < this.chapterList[i].chapter_id_list.length; j++) {
            if (this.chapterList[i].chapter_id_list[j] < 0) {
              for (let y = 0; y < this.videoList.length; y++) {
                if (this.videoList[y].id === this.chapterList[i].chapter_id_list[j]) {
                  const videoPayload = {
                    title: this.videoList[y].title,
                    online_course_id: this.formData.id,
                    duration: this.videoList[y].videoInput.duration
                      ? parseInt(this.videoList[y].videoInput.duration)
                      : 0,
                    video_id: this.videoList[y].videoInput.video_id,
                    description_content: this.videoList[y].description_content,
                    thumbnail: this.videoList[y].thumbnail || '',
                    homework: this.videoList[y].homework.map(el => {
                      return { title: el.title, file: el.file }
                    }),
                  }
                  promises.push({
                    chapter_index: i,
                    chapter_id_index: j,
                    video_index: y,
                    payload: videoPayload,
                  })
                  break
                }
              }
            }
          }
        }

        if (promises.length > 0) {
          results = await this._handleCreateVideoPromises(promises)
        }
      }

      return new Promise(async (resolve, reject) => {
        // 將啲video update返去個course data
        try {
          const chapterCategoryList = this.chapterList.map(el => {
            return {
              title: el.title,
              chapter_id_list: el.chapter_id_list.filter(id => id > -1),
            }
          })
          const updatePayload = {
            ...payload,
            chapter_category_list: chapterCategoryList,
          }

          await this.$Fetcher.UpdateOnlineCourse(this.formData.id, updatePayload)
          const createFail = results.filter(el => el !== true)
          if (createFail.length) {
            resolve(createFail[0])
          } else {
            resolve(true)
          }
        } catch (err) {
          this.$common.error(err)
          reject(err)
        }
      })
    },
    async _handleCreateVideoPromises(promises, count = 0, results = []) {
      if (count < promises.length) {
        try {
          const data = await this.$Fetcher.NewOnlineCourseVideo(promises[count]['payload'])
          // update落 chapter list同video list
          this.chapterList[promises[count]['chapter_index']].chapter_id_list[promises[count]['chapter_id_index']] =
            data.id
          this.videoList[promises[count]['video_index']].id = data.id
          this.savedVideoIds.push(promises[count]['payload']['video_id'])
          results.push(true)
        } catch (err) {
          this.$common.error(err)
          results.push(err)
        } finally {
          count += 1
          return await this._handleCreateVideoPromises(promises, count, results)
        }
      } else {
        return results
      }
    },
    async _updateCourseVideos() {
      // update existing video
      const promises = []
      let results = []
      for (let i = 0; i < this.chapterList.length; i++) {
        for (let j = 0; j < this.chapterList[i].chapter_id_list.length; j++) {
          if (this.chapterList[i].chapter_id_list[j] > -1) {
            const found = this.videoList.find(el => el.id === this.chapterList[i].chapter_id_list[j])
            if (found) {
              const videoPayload = {
                title: found.title,
                duration: found.videoInput.duration ? parseInt(found.videoInput.duration) : 0,
                video_id: found.videoInput.video_id,
                description_content: found.description_content,
                thumbnail: found.thumbnail || '',
                homework: found.homework.map(el => {
                  return { title: el.title, file: el.file }
                }),
              }
              promises.push({
                id: found.id,
                initVideoId: found.initVideoId,
                payload: videoPayload,
              })
            }
          }
        }
      }

      if (promises.length > 0) {
        results = await this._handleUpdateVideoPromises(promises)
      }

      return new Promise(async (resolve, reject) => {
        const updateFail = results.filter(el => el !== true)
        if (updateFail.length) {
          resolve(updateFail[0])
        } else {
          resolve(true)
        }
      })
    },
    async _handleUpdateVideoPromises(promises, count = 0, results = []) {
      if (count < promises.length) {
        try {
          await this.$Fetcher.UpdateOnlineCourseVideo(promises[count]['id'], promises[count]['payload'])
          this.savedVideoIds.push(promises[count]['payload']['video_id'])

          // delete old video
          if (
            this.$validate.DataValid(promises[count]['initVideoId']) &&
            promises[count]['initVideoId'] !== promises[count]['payload']['video_id']
          ) {
            this.savedVideoIds = this.savedVideoIds.filter(el => el !== promises[count]['initVideoId'])
            this.$store.dispatch('insertRemovedVimeoVideoID', promises[count]['initVideoId'])
          }

          results.push(true)
        } catch (err) {
          this.$common.error(err)
          results.push(err)
        } finally {
          count += 1
          return await this._handleUpdateVideoPromises(promises, count, results)
        }
      } else {
        return results
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteOnlineCourse(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'OnlineCourseList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    showPreviewImage(url) {
      this.$store.dispatch('openMediaPopup', { media: url })
    },
    showPreviewVideo(url) {
      this.$store.dispatch('openMediaPopup', { media: url, isVideo: true })
    },

    // ================== 章節 ==================
    // -- (Edit/Add)
    async handleAddChapter(rowId = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.chapterData.title = ''
        await this.$refs.chapterDialog.resetForm()
        if (this.$validate.DataValid(rowId)) {
          const found = this.chapterList.find(el => el.id === rowId)
          if (found) {
            this.chapterData.title = found.title
          }
        }
      } else {
        this.$refs.chapterDialog.setLoading(false)
      }

      const confirm = await this.$refs.chapterDialog.show()
      if (confirm) {
        const obj = {
          title: this.chapterData.title,
        }

        let updated = false
        if (this.$validate.DataValid(rowId)) {
          for (let i = 0; i < this.chapterList.length; i++) {
            if (this.chapterList[i].id === rowId) {
              for (let key in obj) {
                if (this.chapterList[i][key] !== obj[key]) {
                  updated = true
                  this.$set(this.chapterList[i], key, obj[key])
                }
              }
              break
            }
          }
        } else {
          updated = true
          this.count += 1
          this.chapterList.push({
            id: this.count,
            chapter_id_list: [],
            ...obj,
          })
        }

        if (updated && this.dispatchUpdateOnChange) {
          this.$store.dispatch('setDataIsUpdated', true)
        }

        this.$refs.chapterDialog.hide()
      }
    },
    // -- (Delete)
    deleteChapter(rowId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const foundIndex = this.chapterList.findIndex(el => el.id === rowId)
      this.chapterList.splice(foundIndex, 1)
      if (this.dispatchUpdateOnChange) {
        this.$store.dispatch('setDataIsUpdated', true)
      }
    },

    // ================== 影片 ==================
    // -- (Edit/Add)
    async handleAddVideo(id = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        await this.$refs.videoDialog.resetForm()
        this.videoData.title = ''
        this.videoData.chapter = null
        this.videoData.thumbnail_list = []
        this.videoData.description_content = ''
        this.videoData.homework = []
        this.videoData.video_list = []

        if (this.$validate.DataValid(id)) {
          const found = this.videoList.find(el => el.id === id)
          if (found) {
            this.videoData.title = found.title

            const foundChapter = this.chapterList.find(el => (el.chapter_id_list || []).includes(id))
            if (foundChapter) this.videoData.chapter = foundChapter.id

            if (found.thumbnail) {
              this.videoData.thumbnail_list.push({ file: found.thumbnail, name: found.thumbnail })
            }

            this.videoData.description_content = found.description_content

            this.videoData.homework = found.homework.map(item => {
              this.count += 1
              return {
                id: this.count,
                ...item,
              }
            })

            if (found.videoInput) {
              let d = JSON.parse(JSON.stringify(found.videoInput))
              d.is_vimeo = true
              this.videoData.video_list.push(d)
            }
          }
        }
        this.$refs.uploadVideoRef.reset()
        this.$refs.uploadCoverRef.reset()
      } else {
        this.$refs.videoDialog.setLoading(false)
      }

      const confirm = await this.$refs.videoDialog.show()
      if (confirm) {
        let _id = id
        const obj = {
          title: this.videoData.title,
          description_content: this.videoData.description_content,
          thumbnail: this.videoData.thumbnail_list.length ? this.videoData.thumbnail_list[0].file : '',
          videoInput: this.$validate.DataValid(this.videoData.video_list, true)
            ? { ...this.videoData.video_list[0] }
            : null,
          duration: this.$validate.DataValid(this.videoData.video_list, true)
            ? parseInt(this.videoData.video_list[0].duration)
            : 0,
          homework: this.videoData.homework.map(el => {
            return { title: el.title, file: el.file }
          }),
        }

        if (this.$validate.DataValid(id)) {
          for (let i = 0; i < this.videoList.length; i++) {
            if (this.videoList[i].id === id) {
              for (let key in obj) {
                this.$set(this.videoList[i], key, obj[key])
              }
              break
            }
          }
        } else {
          this.count += 1
          _id = this.count * -1
          this.videoList.push({
            id: _id,
            ...obj,
          })
        }

        // update chapter's chapter_id_list
        for (let i = 0; i < this.chapterList.length; i++) {
          if (this.videoData.chapter === this.chapterList[i].id) {
            if (!this.chapterList[i].chapter_id_list.includes(_id)) {
              this.chapterList[i].chapter_id_list.push(_id)
            }
          } else if (this.chapterList[i].chapter_id_list.includes(_id)) {
            const foundPos = this.chapterList[i].chapter_id_list.indexOf(_id)
            this.chapterList[i].chapter_id_list.splice(foundPos, 1)
          }
        }

        if (this.dispatchUpdateOnChange) {
          this.$store.dispatch('setDataIsUpdated', true)
        }

        this.$refs.videoDialog.hide()

        this.$common.logData(this.chapterList, '章節')
        this.$common.logData(this.videoList, '影片')
      }
    },
    // -- (Delete)
    deleteVideo(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const foundIndex = this.videoList.findIndex(el => el.id === id)
      // Update chapter's video list
      for (let i = 0; i < this.chapterList.length; i++) {
        if (this.chapterList[i].chapter_id_list) {
          for (let j = this.chapterList[i].chapter_id_list.length - 1; j >= 0; j--) {
            if (this.chapterList[i].chapter_id_list[j] === id) {
              this.chapterList[i].chapter_id_list.splice(j, 1)
              break
            }
          }
        }
      }
      this.videoList.splice(foundIndex, 1)
      if (this.dispatchUpdateOnChange) {
        this.$store.dispatch('setDataIsUpdated', true)
      }
    },

    getVideoChapterName(id) {
      const foundChapter = this.getVideoChapter(id)
      if (foundChapter) {
        return foundChapter.title
      }

      return ''
    },

    getVideoChapter(id) {
      const foundChapter = this.chapterList.find(el => (el.chapter_id_list || []).includes(id))
      return foundChapter
    },

    async removeVimeo() {
      let removeList = [...this.$store.getters.removedVimeoVideoIDList]
      removeList = removeList.filter(el => !this.savedVideoIds.includes(el))
      return await this.removeUnusedVimeoVideo(removeList)
    },

    // -- 作業
    async handleAddHomework(id = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        await this.$refs.homeworkDialog.resetForm()
        this.homeworkData.title = ''
        this.homeworkData.file_list = []
        if (this.$validate.DataValid(id)) {
          const found = this.videoData.homework.find(el => el.id === id)
          if (found) {
            this.homeworkData.title = found.title
            if (found.file) {
              this.homeworkData.file_list.push({ file: found.file, name: found.file })
            }
          }
        }
        this.$refs.uploadHomeworkFileRef.reset()
      } else {
        this.$refs.homeworkDialog.setLoading(false)
      }

      const confirm = await this.$refs.homeworkDialog.show()
      if (confirm) {
        const obj = {
          title: this.homeworkData.title,
          file: this.homeworkData.file_list.length ? this.homeworkData.file_list[0].file : '',
        }

        if (this.$validate.DataValid(id)) {
          for (let i = 0; i < this.videoData.homework.length; i++) {
            if (this.videoData.homework[i].id === id) {
              for (let key in obj) {
                this.$set(this.videoData.homework[i], key, obj[key])
              }
              break
            }
          }
        } else {
          this.count += 1
          this.videoData.homework.push({
            id: this.count,
            ...obj,
          })
        }

        this.$refs.homeworkDialog.hide()
      }
    },
    previewHomework(file) {
      if (!file) return
      const type = file.split('.').pop()
      if (['png', 'jpeg', 'jpg'].includes(type.toLowerCase())) {
        this.$store.dispatch('openMediaPopup', {
          media: `${this.$mediaPath}${file}`,
        })
      } else {
        window.open(`${this.$mediaPath}${file}`, '_blank')
      }
    },
    deleteHomework(rowId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const foundIndex = this.videoData.homework.findIndex(el => el.id === rowId)
      this.videoData.homework.splice(foundIndex, 1)
    },

    // ================== 導師 ==================
    // -- (Edit/Add)
    async handleAddTutor(rowId = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        await this.$refs.tutorDialog.resetForm()
        this.tutorData.name = ''
        this.tutorData.description = ''
        this.tutorData.icon_list = []

        if (this.$validate.DataValid(rowId)) {
          const found = this.tutorList.find(el => el.id === rowId)
          if (found) {
            this.tutorData.name = found.name
            this.tutorData.description = found.description
            if (found.icon) {
              this.tutorData.icon_list.push({ file: found.icon, name: found.icon })
            }
          }
        }
        this.$refs.uploadTutorIconRef.reset()
      } else {
        this.$refs.tutorDialog.setLoading(false)
      }

      const confirm = await this.$refs.tutorDialog.show()
      if (confirm) {
        const obj = {
          name: this.tutorData.name,
          description: this.tutorData.description,
          icon: this.tutorData.icon_list.length ? this.tutorData.icon_list[0].file : '',
        }
        let update = false
        if (this.$validate.DataValid(rowId)) {
          for (let i = 0; i < this.tutorList.length; i++) {
            if (this.tutorList[i].id === rowId) {
              for (let key in obj) {
                if (this.tutorList[i][key] !== obj[key]) {
                  update = true
                  this.$set(this.tutorList[i], key, obj[key])
                }
              }
              break
            }
          }
        } else {
          update = true
          this.count += 1
          this.tutorList.push({
            id: this.count,
            ...obj,
          })
        }

        if (update && this.dispatchUpdateOnChange) {
          this.$store.dispatch('setDataIsUpdated', true)
        }

        this.$refs.tutorDialog.hide()
      }
    },
    // -- (Delete)
    deleteTutor(rowId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const foundIndex = this.tutorList.findIndex(el => el.id === rowId)
      this.tutorList.splice(foundIndex, 1)
      if (this.dispatchUpdateOnChange) {
        this.$store.dispatch('setDataIsUpdated', true)
      }
    },

    // ================== FAQ ==================
    // -- (Edit/Add)
    async handleAddFAQ(rowId = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        await this.$refs.faqDialog.resetForm()
        this.faqData.question = ''
        this.faqData.answer = ''

        if (this.$validate.DataValid(rowId)) {
          const found = this.faqList.find(el => el.id === rowId)
          if (found) {
            this.faqData.question = found.question
            this.faqData.answer = found.answer
          }
        }
      } else {
        this.$refs.faqDialog.setLoading(false)
      }

      const confirm = await this.$refs.faqDialog.show()
      if (confirm) {
        const obj = {
          question: this.faqData.question,
          answer: this.faqData.answer,
        }
        let update = false
        if (this.$validate.DataValid(rowId)) {
          for (let i = 0; i < this.faqList.length; i++) {
            if (this.faqList[i].id === rowId) {
              for (let key in obj) {
                if (this.faqList[i][key] !== obj[key]) {
                  update = true
                  this.$set(this.faqList[i], key, obj[key])
                }
              }
              break
            }
          }
        } else {
          update = true
          this.count += 1
          this.faqList.push({
            id: this.count,
            ...obj,
          })
        }

        if (update && this.dispatchUpdateOnChange) {
          this.$store.dispatch('setDataIsUpdated', true)
        }
        this.$refs.faqDialog.hide()
      }
    },
    // -- (Delete)
    deleteFAQ(rowId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const foundIndex = this.faqList.findIndex(el => el.id === rowId)
      this.faqList.splice(foundIndex, 1)

      if (this.dispatchUpdateOnChange) {
        this.$store.dispatch('setDataIsUpdated', true)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: OnlineCourseDetails')
      this.userType = this.gfGetUserType()

      await this._getCategoryOptions()
      if (this.$validate.DataValid(this.id)) {
        const getUser = this.gfGetCurrentUserData()
        if (!getUser || !getUser.access_token || !getUser.refresh_token) {
          this.gfForceLogout()
          return
        }
        // edit
        await this._getCourseById()
      }

      this.loading = false
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    this.loading = true
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  async beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      // remove unused vimeo before leave
      await this.removeVimeo()
      next()
    }
  },
}
</script>
